import { useQuery, gql, ApolloError } from '@apollo/client'
import { AppraisalSeasonDto, EmployeeGecoProjectsQuery, EmployeeGecoProjectsQueryVariables } from '../../../types'

export const EMPLOYEE_MOST_BOOKED_GECO_PROJECTS = gql`
  query EmployeeGecoProjects($employeeId: HashedId!, $startDate: String!, $endDate: String!, $limit: Int) {
    mostBookedGecoProjectsOfEmployee(employeeId: $employeeId, startDate: $startDate, endDate: $endDate, limit: $limit) {
      id
      projectName
      bookedTimeInPercent
      hours
    }
  }
`

export default (
  employeeId: string,
  appraisalSeason: AppraisalSeasonDto,
  appraisalUpdate: boolean,
  limit?: number,
): { data: EmployeeGecoProjectsQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const referenceYear: number = appraisalUpdate ? appraisalSeason.year : appraisalSeason.year - 1
  const startDate = `${referenceYear}-01-01`
  const endDate = `${referenceYear}-12-31`

  const { data, error, loading } = useQuery<EmployeeGecoProjectsQuery, EmployeeGecoProjectsQueryVariables>(
    EMPLOYEE_MOST_BOOKED_GECO_PROJECTS,
    {
      variables: {
        employeeId: employeeId,
        startDate: startDate,
        endDate: endDate,
        limit: limit,
      },
      fetchPolicy: 'no-cache',
    },
  )

  return { data, error, loading }
}
